import type { FieldInputProps } from 'formik';
import type { ChangeEvent } from 'react';

/**
 * From and to value transformation for formik fields to use different
 * value shape for the input and in FormikValues model
 */
export interface FormikValueAdapter<TInputValue, TModelValue = any> {
  toInput: (value: TModelValue) => TInputValue;
  toModel: (value: TInputValue) => TModelValue;
}

export const applyFormikValueAdapter = <TInputValue, TModelValue>(
  valueController: Pick<FieldInputProps<TModelValue>, 'value' | 'onChange'>,
  adapter: FormikValueAdapter<TInputValue, TModelValue> | undefined,
): Pick<FieldInputProps<TInputValue>, 'value' | 'onChange'> =>
  adapter
    ? {
        value: adapter.toInput(valueController.value),
        onChange: (e: ChangeEvent<any>) => {
          valueController.onChange({
            target: {
              name: e.target.name,
              value: adapter.toModel(e.target.value),
            },
          });
        },
      }
    : // when no adapter is provided, no transformation is done; no easy way
      // to properly type that, and also inefficient, since Formik's typing
      // of fields is weak anyway.
      (valueController as any);
